<template>
  <CommonVCard>
    <h2 class="registration-form__header pb-4">
      {{ $t("player_registration.payment_confirmation") }}
    </h2>
    <div v-if="Object.keys(playerRegistrationSummary).length">
      <PaymentConfirmationList />
      <PaymentConfirmationSummary
        :readonly="readonly"
        :authorizePayPalPayment="authorizePayPalPayment"
      />
      <PaymentConfirmationPaymentPlan v-if="isPayWithPaymentPlan" />
    </div>
    <div v-else class="d-flex justify-center mt-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </CommonVCard>
</template>

<script>
import CommonVCard from "./CommonVCard";
import PaymentConfirmationPaymentPlan from "./PaymentConfirmationPaymentPlan";
import PaymentConfirmationList from "./PaymentConfirmationList";
import PaymentConfirmationSummary from "./PaymentConfirmationSummary";
import { mapGetters } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";

export default {
  name: "PlayerRegistrationFormPaymentConfirmationCard",
  components: {
    PaymentConfirmationSummary,
    PaymentConfirmationList,
    CommonVCard,
    PaymentConfirmationPaymentPlan
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    authorizePayPalPayment: {
      type: Function,
      default: null
    }
  },

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationSummary"
    ]),
    isPayWithPaymentPlan() {
      return (
        this.playerRegistrationSummary.paymentMethod &&
        this.playerRegistrationSummary?.userPickedPaymentPlan &&
        (!this.readonly
          ? this.playerRegistrationSummary?.withPaymentPlan
          : true)
      );
    }
  }
};
</script>

<style scoped>
.registration-form__header {
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}

.registration-form__header:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: -20px;
  right: -20px;
  height: 1px;
  background-color: var(--divider-color);
}
</style>
